// extracted by mini-css-extract-plugin
export var articleInfoContainer = "bh_dx";
export var articleInfoItem = "bh_dy";
export var itemChild = "bh_dz";